import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from "../../ui/Loader";
import {
  fetchAgentsData,
  fetchInHouseUsersData,
} from "../../../redux/reducers/dropdownApiSlice";
import SelectDropdown from "../../components-react/SelectDropdown";
import { panelTypes } from "../../common-data/DropdowData";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { mapAgentBulk, updateMappedAgent } from "../../../data/ApiEndpoints";
import { commonPostPutApi1 } from "../../../redux/reducers/commonApiSlice";
import {
  BiDashSquareDottedIcon,
  BiPlusSquareDottedIcon,
} from "../../../images/icons/icons";

const AgentMapForm = ({
  isEdit,
  userInfoData,
  closeModal,
  callFunction,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.common);
  const { agents, inhouseUsers } = useSelector((state) => state.dropdown);
  const gymData = useSelector(selectGymData);

  const iniAgentLists = {
    selWtfAgent:
      isEdit && rowData?.user_id && rowData?.wtf_agent_name
        ? {
            label: `${rowData.wtf_agent_name} / ${rowData?.wtf_agent_mobile}`,
            value: rowData.user_id,
            info: {
              name: rowData.wtf_agent_name,
              mobile: rowData?.wtf_agent_mobile,
            },
          }
        : "",
    selMyOperatorAgent:
      isEdit && rowData?.mopr_agent_id && rowData?.mopr_agent_name
        ? {
            label: `${rowData.mopr_agent_name} / ${rowData?.mopr_agent_mobile}`,
            value: rowData.mopr_agent_id,
            info: {
              name: rowData.mopr_agent_name,
              contact_number: rowData?.mopr_agent_mobile,
            },
          }
        : "",
  };

  const iniFormValues = {
    selectedGym:
      isEdit && rowData?.gym_id && rowData?.gym_name
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : "",
    panelType:
      // isEdit && rowData?.panel_type
      //   ? {
      //       label: rowData.panel_type === "panel_1" ? "Main" : "IVR",
      //       value: rowData.panel_type,
      //     }
      //   : ""
      panelTypes[1],
    agents: [],
    agentsList: [iniAgentLists],
  };
  const [formValues, setFormValues] = useState(iniFormValues);

  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeDropdown = (name, value, index) => {
    if (name === "panelType") {
      setFormValues((prev) => ({
        ...prev,
        agents: [],
        agentsList: [{ selMyOperatorAgent: "" }],
        [name]: value,
      }));
    } else if (name === "selectedGym") {
      setFormValues((prev) => ({
        ...prev,
        agentsList: [{ selWtfAgent: "" }],
        [name]: value,
      }));
    }
    if (name === "selWtfAgent" || name === "selMyOperatorAgent") {
      setFormValues((prev) => {
        const updatedAgentsList = [...prev.agentsList];
        updatedAgentsList[index] = {
          ...updatedAgentsList[index],
          [name]: value,
        };
        return {
          ...prev,
          agentsList: updatedAgentsList,
        };
      });
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const addMoreAgents = () => {
    setFormValues((prev) => ({
      ...prev,
      agentsList: [
        ...prev.agentsList,
        {
          selWtfAgent: "",
          selMyOperatorAgent: "",
        },
      ],
    }));
  };

  const removeAgentSet = (index) => {
    setFormValues((prev) => {
      const updatedAgentsList = prev.agentsList.filter((_, i) => i !== index);
      return {
        ...prev,
        agentsList: updatedAgentsList,
      };
    });
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    // if (!formValues.panelType) {
    //   errors.panelType = "Required!";
    // }

    formValues.agentsList.forEach((agent, index) => {
      if (!agent.selWtfAgent) {
        errors[`agentsList[${index}].selWtfAgent`] = "Required!";
      }
      if (!agent.selMyOperatorAgent) {
        errors[`agentsList[${index}].selMyOperatorAgent`] = "Required!";
      }
    });

    return errors;
  };

  function getAgents(filter) {
    dispatch(
      fetchAgentsData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  function getInhouseUsers() {
    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: formValues.selectedGym?.value
          ? `gym_id=${formValues.selectedGym.value}`
          : "",
        pageNo: 1,
        limit: 500,
      })
    );
  }

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? updateMappedAgent : mapAgentBulk;
    const payload = requestBody;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi1({ method, endpoint, payload, token })
      );

      console.log("result=> ", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
  }, []);

  useEffect(() => {
    getInhouseUsers();
  }, [formValues.selectedGym]);

  useEffect(() => {
    if (formValues.panelType) {
      const filters = {
        page: 1,
        page_size: 300,
        is_mapped: 0,
        panel_type: formValues.panelType?.value || "",
      };

      getAgents(filters);
    }
  }, [formValues.panelType]);

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      selectedGym:
        isEdit && rowData?.gym_id && rowData?.gym_name
          ? {
              label: rowData.gym_name,
              value: rowData.gym_id,
            }
          : "",
      // panelType:
      //   isEdit && rowData?.panel_type
      //     ? {
      //         label: rowData.panel_type === "panel_1" ? "Main" : "IVR",
      //         value: rowData.panel_type,
      //       }
      //     : "",
      selWtfAgent:
        isEdit && rowData?.user_id && rowData?.wtf_agent_name
          ? {
              label: `${rowData.wtf_agent_name} / ${rowData?.wtf_agent_mobile}`,
              value: rowData.user_id,
              info: {
                name: rowData.wtf_agent_name,
                mobile: rowData?.wtf_agent_mobile,
              },
            }
          : "",
      selMyOperatorAgent:
        isEdit && rowData?.mopr_agent_id && rowData?.mopr_agent_name
          ? {
              label: `${rowData.mopr_agent_name} / ${rowData?.mopr_agent_mobile}`,
              value: rowData.mopr_agent_id,
              info: {
                name: rowData.mopr_agent_name,
                contact_number: rowData?.mopr_agent_mobile,
              },
            }
          : "",
    }));
  }, [rowData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        gym_id: formValues.selectedGym?.value || "",
        panel_type: formValues.panelType?.value,
      };

      if (isEdit) {
        const formValues_ = formValues.agentsList[0] || {};

        userData.uid = rowData?.uid || "";
        userData.mopr_agent_id = formValues_.selMyOperatorAgent?.value || "";
        userData.user_id = formValues_.selWtfAgent?.value || "";
        userData.mopr_agent_name =
          formValues_.selMyOperatorAgent?.info?.name || "";
        userData.mopr_agent_mobile =
          formValues_.selMyOperatorAgent?.info?.contact_number || "";
        userData.wtf_agent_name = formValues_.selWtfAgent?.info?.name || "";
        userData.wtf_agent_mobile = formValues_.selWtfAgent?.info?.mobile || "";
      } else {
        userData.map_bulk_data = formValues.agentsList.map((agent) => ({
          user_id: agent.selWtfAgent?.value || "",
          mopr_agent_id: agent.selMyOperatorAgent?.value || "",
          wtf_agent_name: agent.selWtfAgent?.info?.name || "",
          mopr_agent_name: agent.selMyOperatorAgent?.info?.name || "",
          wtf_agent_mobile: agent.selWtfAgent?.info?.mobile || "",
          mopr_agent_mobile:
            agent.selMyOperatorAgent?.info?.contact_number || "",
        }));
      }

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(handleConfirm, `Are you sure!`);
    }
  }, [isSubmit, formErrors]);

  console.log(" <=formErrors=> ", formErrors);

  return (
    <div className="form-container add-new-job">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          {/* <div className="formInputBox">
            <label htmlFor="panelType" className={`formInputLabel `}>
              Panel Type *
            </label>

            <div
              className={`commonWrapper ${
                formErrors.panelType ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={panelTypes}
                selectedOption={formValues.panelType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("panelType", selectedValue)
                }
                name="Panel Type"
              />
            </div>
          </div> */}

          <div className="formInputBox">
            <label htmlFor="selectedGym" className="formInputLabel">
              Gym
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGym ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={gymData}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedGym", selectedValue)
                }
                name="Gym"
              />
            </div>
          </div>

          {formValues.panelType ? (
            <>
              {formValues.agentsList.map((agent, index) => (
                <div className="add-more-btn-with-input span2">
                  <div className="inputs">
                    <div className="formInputBox">
                      <label htmlFor="selWtfAgent" className="formInputLabel">
                        WTF Agents *
                      </label>

                      <div
                        className={`commonWrapper ${
                          formErrors[`agentsList[${index}].selWtfAgent`]
                            ? "formError"
                            : ""
                        }`}
                      >
                        <SelectDropdown
                          options={inhouseUsers}
                          selectedOption={agent.selWtfAgent}
                          setSelectedOption={(selectedValue) =>
                            onChangeDropdown(
                              "selWtfAgent",
                              selectedValue,
                              index
                            )
                          }
                          name="WTF Agent"
                        />
                      </div>
                    </div>

                    <div className="formInputBox">
                      <label
                        htmlFor="selMyOperatorAgent"
                        className="formInputLabel"
                      >
                        {/* My Operator Agents  */}
                        IVR Agents *
                      </label>

                      <div
                        className={`commonWrapper ${
                          formErrors[`agentsList[${index}].selMyOperatorAgent`]
                            ? "formError"
                            : ""
                        }`}
                      >
                        <SelectDropdown
                          options={agents}
                          selectedOption={agent.selMyOperatorAgent}
                          setSelectedOption={(selectedValue) =>
                            onChangeDropdown(
                              "selMyOperatorAgent",
                              selectedValue,
                              index
                            )
                          }
                          name="Agent"
                        />
                      </div>

                      {agent.selWtfAgent?.info?.mobile !==
                      agent.selMyOperatorAgent?.info?.contact_number ? (
                        <span className="info">
                          WTF Agent mobile number{" "}
                          <b>{agent.selWtfAgent?.info?.mobile || ""}</b> and IVR
                          Agent mobile number{" "}
                          <b>
                            {agent.selMyOperatorAgent?.info?.contact_number ||
                              ""}
                          </b>{" "}
                          do not match!
                        </span>
                      ) : null}
                    </div>
                  </div>
                  {!isEdit && (
                    <div className="btn-add-more">
                      {formValues.agentsList?.length > 1 && (
                        <button
                          type="button"
                          className="btn remove"
                          onClick={() => removeAgentSet(index)}
                        >
                          <BiDashSquareDottedIcon />
                        </button>
                      )}

                      {formValues.agentsList?.length - 1 === index && (
                        <button
                          type="button"
                          className="btn add"
                          onClick={addMoreAgents}
                        >
                          <BiPlusSquareDottedIcon />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </>
          ) : null}
        </div>

        <div
          className="formButtons mt30"
          style={{ justifyContent: "flex-end" }}
        >
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {loading ? <Loader /> : `${isEdit ? "Update" : "Submit"}`}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AgentMapForm;
